import {createRouter, createWebHistory} from "vue-router";
import Home from "../views/Home.vue";
import Shop from "../views/Shop.vue";
import Cart from "../views/Cart.vue";
import Auth from "../views/Auth.vue";
import Payment from "../views/Payment.vue";
import Final from "../views/Final.vue";
import ProductDetail from "../components/Sections/Products/ProductDetail/ProductDetail";
import Profile from "../views/Profile.vue";
import Wishlist from "../views/Wishlist.vue";
import ProductsByCategory from "../views/ProductsByCategory";
import ProductsByType from "../views/ProductsByType";
import Checkout from "../views/Checkout";
import Search from "../views/Search";
import Orders from "../views/Orders";
import Thankyou from "../views/Thankyou";
import NotFoundPage from "../views/NotFoundPage";
import OrderDetails from "../views/OrderDetails";
import PaymentStatus from "../views/PaymentStatus";
import AddReview from "../views/AddReview";
import ChangePassword from "../views/ChangePassword";
import ForgotPassword from "../views/ForgotPassword";
import ResetPassword from "../views/ResetPassword";
import Invoice from "../views/Invoice";
import SellerRegister from "../views/SellerRegister";
import TermsAndConditions from "../views/TermsAndConditions";
import Seller from "../views/Seller";
import PostRequirements from "../views/PostRequirements";
import Requirements from "../views/Requirements";
import Client from "../views/Client";
 import CashBack from "../views/CashBack";

function isLoggedIn(to = null, params = null) {
	if (localStorage.getItem("token") == null) {
		// if token is not available
		if (to) {
			// to : object that contains the path and query
			localStorage.setItem("redirect", to.name); // set redirect path
		}
		if(params){
			localStorage.setItem("redirect_params", params); // set redirect hash
		}
		return false;
	}
	return true; // if token is available
}
function titleize(slug) {
	var words = slug.split("-");
	return words
		.map(function (word) {
			return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase();
		})
		.join(" ");
}

function conversionTrack(query) {
	const query_params = ["gclid", "fcid"];
	const query_param = Object.keys(query).find((param) =>
		query_params.includes(param)
	);
	if (query_param) {
		localStorage.setItem("conversion", query_param);
	} else {
		localStorage.removeItem("conversion");
	}
}

const routes = [
	{
		path: "/",
		name: "Home",
		component: Home,
		meta: {
			title: `Home | ${process.env.VUE_APP_SHOP_NAME}`,
		},
	},
	{
		path: "/shop",
		name: "Shop",
		component: Shop,
	},
	{
		path: "/cart",
		name: "Cart",
		component: Cart,
		meta: {
			title: "My Cart",
		},
	},
	{
		path: "/account",
		name: "Auth",
		component: Auth,
		beforeEnter: (to, from) => {
			isLoggedIn() ? router.push({name: "Home"}) : true;
		},
		meta: {
			title: "Login | Register",
		},
	},
	{
		path: "/seller-register",
		name: "SellerRegister",
		component: SellerRegister,
		beforeEnter: (to, from) => {
			isLoggedIn() ? router.push({name: "Home"}) : true;
		},
		meta: {
			title: "Seller Register",
		},
	},
	{
		path: "/product/:id/:slug",
		name: "ProductDetail",
		component: ProductDetail,
	},
	{
		path: "/profile",
		name: "Profile",
		component: Profile,
		beforeEnter: (to, from) => {
			isLoggedIn(to) ? true : router.push({name: "Auth"});
		},
		meta: {
			title: "My Profile",
		},
	},
	{
		path: "/wishlist",
		name: "Wishlist",
		component: Wishlist,
		beforeEnter: (to, from) => {
			isLoggedIn(to) ? true : router.push({name: "Auth"});
		},
	},
	{
		path: "/category/:id/:slug/products",
		name: "ProductsByCategory",
		component: ProductsByCategory,
	},
	{
		path: "/products/:type",
		name: "ProductsByType",
		component: ProductsByType,
	},
	{
		path: "/checkout",
		name: "Checkout",
		component: Checkout,
		beforeEnter: (to, from) => {
			isLoggedIn(to) ? true : router.push({name: "Auth"});
		},
	},
	{
		path: "/orders",
		name: "Orders",
		component: Orders,
		beforeEnter: (to, from) => {
			isLoggedIn(to) ? true : router.push({name: "Auth"});
		},
	},
	{
		path: "/thankyou",
		name: "Thankyou",
		component: Thankyou,
		beforeEnter: (to, from) => {
			isLoggedIn() ? true : router.push({name: "Auth"});
		},
	},
	{
		path: "/search",
		name: "Search",
		component: Search,
	},
	{
		path: "/payment",
		name: "Payment",
		component: Payment,
		beforeEnter: (to, from) => {
			isLoggedIn() ? true : router.push({name: "Auth"});
		},
	},
	{
		path: "/final",
		name: "Final",
		component: Final,
		beforeEnter: (to, from) => {
			isLoggedIn() ? true : router.push({name: "Auth"});
		},
	},
	{
		path: "/order/:id",
		name: "OrderDetails",
		component: OrderDetails,
		beforeEnter: (to, from) => {
			isLoggedIn(to, JSON.stringify(to.params)) ? true : router.push({name: "Auth"});
		},
		meta: {
			title: "Order Details",
		},
	},
	{
		path: "/payment-status/:status",
		name: "PaymentStatus",
		component: PaymentStatus,
		beforeEnter: (to, from) => {
			isLoggedIn() ? true : router.push({name: "Auth"});
		},
	},
	{
		path: "/add-review",
		name: "AddReview",
		component: AddReview,
		props: true,
		beforeEnter: (to, from) => {
			isLoggedIn(to) ? true : router.push({name: "Auth"});
		},
		meta: {
			title: "Add Your Review",
		},
	},
	{
		path: "/change-password",
		name: "ChangePassword",
		component: ChangePassword,
		props: true,
		beforeEnter: (to, from) => {
			isLoggedIn() ? true : router.push({name: "Auth"});
		},
		meta: {
			title: "Change Password",
		},
	},
	{
		path: "/invoice",
		name: "Invoice",
		component: Invoice,
		props: true,
		beforeEnter: (to, from) => {
			isLoggedIn() ? true : router.push({name: "Auth"});
		},
	},
	{
		path: "/forgot-password",
		name: "ForgotPassword",
		component: ForgotPassword,
		props: true,
		meta: {
			title: "Forgot Password",
		},
	},
	{
		path: "/reset-password/:token",
		name: "ResetPassword",
		component: ResetPassword,
		props: true,
		meta: {
			title: "Reset Password",
		},
	},
	{
		path: "/terms-and-conditions",
		name: "TermsAndConditions",
		component: TermsAndConditions,
		meta: {
			title: "Terms and Conditions",
		},
	},
	{
		path: "/seller/:slug",
		name: "Seller",
		component: Seller,
	},
	{
		path: "/post-automation-requirement",
		name: "PostRequirements",
		component: PostRequirements,
		meta: {
			title: "Post Automation Requirements",
		},
	},
	{
		path: "/automation-requirements",
		name: "Requirements",
		component: Requirements,
		meta: {
			title: "Automation Requirements",
		},
	},
	{
		path: "/client",
		name: "Client",
		component: Client,
	},
	{
		path: "/404",
		component: NotFoundPage,
		name: "404",
	},
	{
		path: "/cash-back/:id",
		component: CashBack,
		name: "CashBack",
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/404",
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	scrollBehavior() {
		document.getElementById("app").scrollIntoView();
	},
	routes,
});
router.beforeEach((toRoute, fromRoute, next) => {
	// here we can add some logic before each route change
	let title; // default title
	switch (
		toRoute.name // if route has a name
	) {
		case "ProductsByCategory":
			title = `Category | ${titleize(toRoute.params.slug)}`;
			break;
		case "ProductsByType":
			title = `${titleize(toRoute.params.type)} - Products`;
			break;
		case "ProductDetail":
			title = `Product | ${titleize(toRoute.params.slug)}`;
			conversionTrack(toRoute.query);
			break;
		case "Search":
			title = `Search For - ${toRoute.query.q}`;
			break;
		case "Seller":
			title = `Seller | ${titleize(toRoute.params.slug)}`;
			break;
		default:
			title = toRoute.meta.title ? toRoute.meta.title : toRoute.name;
	}
	window.document.title = title; // set title
	next();
});

export default router;
